<influencer-module-container [title]="'INFLUENCER.overview.related_influencers.title' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="361">

    <div class="related-inf-container">
        <div class="row related-inf-row">
            <ng-container *ngIf="!hasNoData && !isFetchingData">
                <div *ngFor="let influencer of drawnRelatedInfluencers" class="related-inf-col">
                    <related-influencer-item [influencer]="influencer"></related-influencer-item>
                </div>
            </ng-container>

            <ng-container *ngIf="hasNoData || isFetchingData">
                <div *ngFor="let i of placeholderIndicies" class="related-inf-col">
                    <related-influencer-item [placeholderMode]="true"></related-influencer-item>
                </div>
            </ng-container>
            
        </div>
    </div>
</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/related-influencers/related-influencers.component.html